























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { dictServe, menuServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: {},
})
export default class AddUser extends Vue {
  @Prop(Object) rowData!: any; // 传递给编辑页面-数据对象
  private title: any = ''; // dialog 标题
  private type = ''; // 触发弹框方式
  private pName: any = ''; // 展示上级菜单中文
  private pStatus: any = false; // 展示上级菜单中文
  scrollbar = true;

  private treeDataStore: any = []; // 存储树形图list
  dialogTitle = ''; // dialog 标题
  checkNode: any = {}; // 被选中的节点数据
  private organDialogVisible = false; // 触发弹框方式
  treeData: any[] = [
    {
      label: '一级 1',
      id: '1',
      children: [
        {
          label: '二级 1-1',
          id: '1-1',
          children: [
            {
              label: '三级 1-1-1',
              id: '1-1-1',
            },
          ],
        },
      ],
    },
  ];
  // dialog 中树形图的属性
  defaultProps: object = {
    children: 'children',
    label: 'label',
  };
  // 表单数据
  private formData: any = {
    id: '',
    dictId: '', // 上级字典id
    label: '', // 字典标签
    sort: 0, // 排序
    value: '', // 字典值
  };
  // 表单验证规则
  formRules: object = {
    type: [{ required: true, message: '必填信息', trigger: 'blur' }], // 菜单类型验证规则
    homeModule: [{ required: true, message: '必填信息', trigger: 'blur' }], // 归属模块验证规则
  };

  created() {
    this.getMenuListData();
    if (this.rowData.id) {
      this.type = 'edit';
      this.title = '编辑字典';
      this.getSingleDictTypeListData(this.rowData.id);
    } else {
      this.type = 'add';
      this.title = '新增字典';
    }
  }

  mounted() {
    this.hasScrollbar();
  }

  hasScrollbar() {
    const dom: any = document.getElementById('main_box');
    this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
  }

  /**
   * @desc 获取所有上级数据
   * @param1 暂无
   * @returns 暂无
   */
  getMenuListData() {
    // 发起接口请求，获取分页数据
    dictServe
      .getAllDictTypeList({})
      .then((res: any) => {
        this.treeData = arrayToTree(res.data);
        this.treeDataStore = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 通过主键查询单条数据
   * @param1 暂无
   * @returns 暂无
   */
  private getSingleDictTypeListData(id: any) {
    // 通过主键查询单条数据
    dictServe
      .getSingleDictTypeData(id)
      .then((res: any) => {
        this.formData = res.data;
        setTimeout(() => {
          this.pName = this.getTreeNodeName(res.data.dictId);
        }, 50);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  private getTreeNodeName(id: any) {
    if (!id) {
      return null;
    }
    for (let i = 0, len = this.treeDataStore.length; i < len; i++) {
      const item = this.treeDataStore[i];
      if (item.id == id) {
        return item.name;
      }
    }
    return null;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 打开 上级菜单 dialog
   * @param1 name: dialog 弹框名称。
   * @param2 data: 菜单管理的内容
   * @returns 暂无
   */
  openOrganDialog(name: any, data?: any): void {
    this.dialogTitle = name; // dialog 标题
    this.checkNode.id = data.dictId ? data.dictId : ''; // 打开归属机构的dialog 让选中节点是data;
    this.organDialogVisible = true;
    this.$nextTick(() => {
      (this.$refs.searchOrganRef as any).focus();
      // 打开被选中的树
      this.openCheckedTree(this.treeData, data);
      // 打开一层目录
      this.treeData.forEach(item => {
        (this.$refs.dialogTreeRef as any).getNode(item.id).expanded = true;
      });
    });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击上级菜单 input 触发事件，打开被选中的树节点。
   * @param1 tree: 树节点对象
   * @param2 name: 用于进行判断的名称
   * @returns 返回值描述
   */
  openCheckedTree(tree: any, data?: any) {
    tree.forEach((item: any) => {
      if (item.id === data.dictId) {
        (this.$refs.dialogTreeRef as any).getNode(item.id).isCurrent = true;
        (this.$refs.dialogTreeRef as any).getNode(item.id).parent.expanded = true;
      } else if (item.children) {
        this.openCheckedTree(item.children, data);
      }
    });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 每次点击树节点都会触发的事件，获得当前点击的id
   * @param1 data: 被点击的节点数据对象
   * @returns 暂无
   */
  handleNodeClick(data?: any) {
    // 取消被选中的 树节点。
    (this.$refs.dialogTreeRef as any).store._getAllNodes().forEach((item: any, i: number) => {
      if (item.data !== data) {
        (this.$refs.dialogTreeRef as any).getNode(item.data.id).isCurrent = false;
      }
    });
    this.checkNode = data; // 选中的节点数据
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 保存并提交编辑、新增
   * @param1 暂无
   * @returns 暂无
   */
  save(): void {
    const formComponent: any = this.$refs.form;
    formComponent.validate((valid: any) => {
      if (!valid) {
        return;
      }
      switch (this.type) {
        case 'add':
          this.addFunctionData();
          break;
        case 'edit':
          this.editFunctionData();
          break;
      }
    });
  }

  /**
   * 【接口】新增功能
   */
  private async addFunctionData() {
    dictServe
      .addDictTypeData({
        id: this.formData.id,
        dictId: this.formData.dictId, // 上级字典id
        label: this.formData.label, // 字典标签
        sort: this.formData.sort, // 排序
        value: this.formData.value, // 字典值
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('添加成功');
          this.close(); // 返回到父级页面
        }
      })
      .catch(() => {
        this.$message.error('添加失败,请稍后重试!');
      });
  }

  /**
   * 【接口】编辑功能
   */
  private async editFunctionData() {
    dictServe
      .editDictTypeData({
        id: this.formData.id,
        dictId: this.formData.dictId, // 上级字典id
        label: this.formData.label, // 字典标签
        sort: this.formData.sort, // 排序
        value: this.formData.value, // 字典值
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('保存成功');
          this.close(); // 返回到父级页面
        }
      })
      .catch(() => {
        this.$message.error('保存失败,请稍后重试!');
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击关闭按钮，返回上一级.
   * @param1 暂无
   * @returns 暂无
   */
  close(): void {
    this.pName = '';
    this.formData = {
      id: '',
      dictId: '', // 上级字典id
      label: '', // 字典标签
      sort: 0, // 排序
      value: '', // 字典值
    };
    this.$emit('on-response');
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击关闭按钮，返回上一级.
   * @param1 暂无
   * @returns 暂无
   */
  closeOrganDialog(): void {
    this.formData.info = '';
    this.checkNode = {}; // 将选中的节点数据清空
    this.organDialogVisible = false;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击确定按钮，保存数据并返回上一级.
   * @param1 暂无
   * @returns 暂无
   */
  submitOrgan(): void {
    if (this.formData.id === this.checkNode.id) {
      this.$message.warning('请不要自己套自己');
      return;
    } else {
      this.formData.dictId = this.checkNode.id;
      this.pName = this.checkNode.name;
      this.organDialogVisible = false; // 关闭归属机构的 dialog
    }
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击清除按钮，回到最初状态.
   * @param1 暂无
   * @returns 暂无
   */
  clearOrgan(): void {
    this.getMenuListData();
    this.getSingleDictTypeListData(this.formData.id);
  }
}
